import classNames from 'classnames';
import React from 'react';
import * as LoadingSkeleton from 'react-loading-skeleton';

import './Skeleton.scss';

const LoadingSkeletonComponent = LoadingSkeleton.default;

const Skeleton = ({ width = '100%', className, containerClassName, ...rest }: LoadingSkeleton.SkeletonProps) => {
    return (
        <LoadingSkeletonComponent
            className={classNames('sgw-skeleton', className)}
            containerClassName={containerClassName}
            width={width}
            {...rest}
        />
    );
};

export default Skeleton;
